import { render, staticRenderFns } from "./ExpenseDashboard.vue?vue&type=template&id=df80501a&scoped=true&"
import script from "./ExpenseDashboard.vue?vue&type=script&lang=js&"
export * from "./ExpenseDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df80501a",
  null
  
)

export default component.exports